module.exports = __webpack_public_path__ + "img/drag-arrows.8aad6b57.svg";